import React, { useRef } from 'react';

import ModalAiArtist from './ModalAiArtist';

import RobotImg from '../../../../../Images/gallery/ai-services/not-robot.png';
import Video1 from '../../../../../Images/gallery/ai-services/not-robot/video-1.png';
import Video2 from '../../../../../Images/gallery/ai-services/not-robot/video-2.png';
import Video3 from '../../../../../Images/gallery/ai-services/not-robot/video-3.png';

import {
  Robot_Title,
  Robot_Text,
  Robot_Video1,
  Robot_Video2,
  Robot_Video3,
} from '../../../../../utils/ES/Modals/aiArtists';

const ModalRobot = () => {
  return (
    <>
      <ModalAiArtist
        id="artist-not-robot"
        artistImage={RobotImg}
        artistName="Not Robot"
        artistTitle={Robot_Title}
        artisText={Robot_Text}
        videoRef1={'robot-video-1'}
        videoBg1={Video1}
        videoText1={Robot_Video1}
        videoRef2={'robot-video-2'}
        videoBg2={Video2}
        videoText2={Robot_Video2}
        videoRef3={'robot-video-3'}
        videoBg3={Video3}
        videoText3={Robot_Video3}
      />
    </>
  );
};

export default ModalRobot;
